import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

/** Figma 2858:215611 — dropdown result row. */
export const ItemButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: ${spacing[2]} ${spacing[3]};
  border: none;
  border-radius: ${borderRadius.lg};
  background: transparent;
  cursor: pointer;
  text-align: left;
  gap: 2px;

  &:hover {
    background-color: ${rawColors.primary[100]};
  }

  &:focus-visible {
    outline: 2px solid ${rawColors.primary[500]};
    outline-offset: 0;
  }
`;

export const PrimaryLine = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  width: 100%;
`;

export const SecondaryLine = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
  width: 100%;
`;
